var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSetDevice = function SvgSetDevice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "set_device_svg__st0",
    d: "M12 0C8.25 2.87 5.91 3 2 3v11.53c0 4.6 3.56 5.8 10 9.47 6.44-3.66 10-4.86 10-9.47V3c-3.91 0-6.25-.13-10-3zm5.71 9.71-6 6c-.2.2-.45.29-.71.29s-.51-.1-.71-.29l-4-4A.996.996 0 1 1 7.7 10.3l3.29 3.29 5.29-5.29c.39-.39 1.02-.39 1.41 0s.41 1.02.02 1.41z"
  })));
};
export default SvgSetDevice;